import { Component, Input, OnInit, Output, ViewEncapsulation, EventEmitter } from '@angular/core';

@Component({
    selector: 'drop-down-menu',
    templateUrl: './drop-down-menu.component.html',
    styleUrls: ['./drop-down-menu.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class DropDownMenuComponent implements OnInit {

    @Output() openChange = new EventEmitter<boolean>();

    @Input() open: boolean = false;
    @Input() closeLabel: string;
    @Input() title: string;
    @Input() fullScreenMobile: boolean = false;
    @Input() headerButtonLabel: string;
    @Input() showHeaderButton: boolean = false;

    @Output() headerButtonClicked = new EventEmitter<void>();

    constructor() { }

    ngOnInit(): void {
    }

    public toggleOpen(open: boolean = !this.open) {
        this.open = open;
        this.openChange.emit(this.open);
    }
}
